import React, { useState } from 'react';
import Table from '@RHEnvironmental/pattern-library/dist/js/components/Table';
import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import ScrollableArea from '../ScrollableArea';

import role from '../../../services/ui/role';
import date from '../../../services/ui/date';
import OfficerForm from '../../forms/Officer';

const OfficerList = ({
    officers,
    officerInvites,
    roles,
    sessionUser,
    canEdit = true,
}) => {
    const [selectedOfficer, setSelectedOfficer] = useState(null);

    return (
        <>
            {!selectedOfficer ? (
                <ScrollableArea>
                    <Table className="table--full-width">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Joined</th>
                            </tr>
                        </thead>
                        <tbody>
                            {officers.map((officer) => (
                                <tr
                                    key={officer.id}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        if (!canEdit) return;
                                        setSelectedOfficer(officer);
                                    }}
                                >
                                    <td data-th="">{officer.full_name}</td>
                                    <td data-th="">{officer.email}</td>
                                    <td data-th="">
                                        {role.forOfficer(officer).name}
                                    </td>
                                    <td data-th="">
                                        {date.short(officer.created_at)}
                                    </td>
                                </tr>
                            ))}

                            {officerInvites.map((invite) => (
                                <tr key={invite.id}>
                                    <td data-th="">Invited Officer</td>
                                    <td data-th="">{invite.email}</td>
                                    <td data-th="" />
                                    <td data-th="">
                                        Invite sent on{' '}
                                        {date.short(invite.created_at)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ScrollableArea>
            ) : (
                <div className="officer-details">
                    <div className="officer-details__list">
                        <Table className="table--full-width">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {officers.map((officer) => (
                                    <tr
                                        key={officer.id}
                                        onClick={() => {
                                            if (!canEdit) return;
                                            setSelectedOfficer(officer);
                                        }}
                                    >
                                        <td data-th="">{officer.full_name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                    <div className="officer-details__content">
                        <div className="flex space-between align-baseline">
                            <PageHeading level={3} className="mb-4">
                                Details
                            </PageHeading>
                            <Button onClick={() => setSelectedOfficer(null)}>
                                Close
                            </Button>
                        </div>

                        <PageHeading level={4} className="mb-1">
                            {selectedOfficer.full_name}
                        </PageHeading>
                        <PageHeading level={4} className="mb-4">
                            {selectedOfficer.email}
                        </PageHeading>
                        <OfficerForm
                            onSuccess={() => null}
                            key={selectedOfficer.id}
                            officer={selectedOfficer}
                            roles={roles}
                            sessionUser={sessionUser}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default OfficerList;
